import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { informationForRolloffSizeSourgum } from '../../utils/information-for-roll-off-size';
import ErrorBoundary from './ErrorBoundary';
export function DumpsterSizeImage({ size, iconSize, className, ...props }) {
    const { image: DumpsterIcon, pickups } = informationForRolloffSizeSourgum[size] || {};
    let iconWidth;
    if (iconSize) {
        iconWidth = iconSize;
    }
    else if (window.innerWidth >= 1280) {
        iconWidth = 280;
    }
    else {
        iconWidth = 176;
    }
    return (_jsxs("div", { className: `${className ? className : ''} bg-surface-secondary relative flex h-auto flex-col items-center justify-center gap-y-1.5 overflow-clip`, ...props, children: [_jsxs("div", { className: `absolute -m-1 rounded-lg border border-[#E1E1E1] bg-white px-2 py-1 text-center text-xs leading-[14px] tracking-tight text-zinc-500`, style: { left: '12px', top: '12px' }, children: ["Fits ", pickups, " Pickup Truck Beds"] }), _jsx(ErrorBoundary, { children: _jsx("div", { className: "mt-8", children: _jsx(DumpsterIcon, { width: iconWidth }) }) })] }));
}
//# sourceMappingURL=DumpsterSizeImage.js.map